<template>
  <div >
    <div class="gameplay_title_container">

      <div class="gameplay_title">
        {{ getTranslations.home_game_memory_attention_question }}      </div>
    </div>

    <div class="gameplay_game_box memory6" >
      <img :src="gameInfo.img" @load="loadImage" class="">
    </div>
  </div>
</template>
<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { gameplayFooter } from '@/common/jQuery';

export default {
  name: 'MemoryAttention',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      gameInfo: null,
      timeToViewTheList: null,
    };
  },
  created() {
    console.log('in Game created hook');
    this.initGameData();
  },
  mounted() {
    this.getTheFinalList();
  },
  methods: {
    ...mapMutations('game', [
      'resetGameState',
    ]),
    loadImage() {
      gameplayFooter();
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
    },
    getTheFinalList() {
      setTimeout(() => {
        this.changeBrainiacMiniGameType('MEMORY_ATTENTION_LIST');
      }, this.gameInfo.timer);
    },
    changeQuestionText() {
      if (this.timeToViewTheList === true) {
        return this.gameInfo.question;
      }
      return 'Watch the image carefully You will answer a question.';
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'gameType',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/memory/MemoryAttention.vue